module.exports = __webpack_public_path__ + "static/media/Commercial-disputes-01.4667f93b.png";